import { Instance } from 'src/types/instance';

export const INSTANCE_CONSTANTS = {
  FIRST_STEP: 1,
  SECOND_STEP: 2,
  THIRD_STEP: 3,
};

export const PROFILE_DATA_CONSTANTS = {
  USER: 'USER',
  USER_LIST: 'USER_LIST',
  NUMBER: 'NUMBER',
  NUMBER_LIST: 'NUMBER_LIST',
  STRING: 'STRING',
  STRING_LIST: 'STRING_LIST',
  DATE: 'DATE',
  OPTION: 'OPTION',
  MULTIPLE_OPTION: 'MULTIPLE_OPTION',
};

export const getBasicInputs = (instance: Instance) => {
  const options = [
    {
      name: 'firstName',
      label: 'FIRST_NAME',
      required: true,
      enable: instance.editableName,
    },
    {
      name: 'lastName',
      label: 'LAST_NAME',
      required: true,
      enable: instance.editableName,
    },
    {
      name: 'nickname',
      label: 'NICK_NAME',
      required: false,
      enable: instance.allowNickname,
    },
  ];
  return options;
};

export const SOCIAL_INPUTS = [
  {
    allow: 'allowLinkedin',
    name: 'linkedIn',
    label: 'LINKED_IN',
    type: 'url',
  },
  {
    allow: 'allowInstagram',
    name: 'instagram',
    label: 'INSTAGRAM',
    type: 'url',
  },
  {
    allow: 'allowFacebook',
    name: 'facebook',
    label: 'FACEBOOK',
    type: 'url',
  },
  {
    allow: 'allowTwitter',
    name: 'twitter',
    label: 'TWITTER',
    type: 'url',
  },
];
